import loadScript from 'load-script2';

const LIMELIGHT_IFRAME_API_SRC =
  'https://video.limelight.com/player/limelightjs-player.js?orgId=3ee7b65cff5f4484b6ad3f9565c13737';

export default class LimeLightPlayer {
  constructor({ settings = {}, parent }) {
    this.videoSettings = {
      height: '100%',
      width: '100%',
      playerForm: 'LVPPlayerStandard',
      ...settings
    };
    this.parent = parent;
    this.createContainer();
  }

  createContainer() {
    const container = document.createElement('div');
    const playerId = `id${Math.random().toString(16).slice(2)}`;
    container.id = playerId;
    this.videoSettings = { ...this.videoSettings, playerId };
    this.parent.appendChild(container);
    this.playerId = playerId;

    this.loadIframeAPI();
  }

  getPlayer() {
    this.player = this.parent.querySelector(`#${this.playerId}`);
    this.loaded = true;
  }

  play() {
    this.player.doPlay();
  }

  pause() {
    this.player?.doPause();
  }

  load(newMediaId, autoPlay = false, positionInMilliseconds = 0) {
    this.getPlayer();
    this.player.doLoadMedia(newMediaId, autoPlay, positionInMilliseconds);
  }

  async loadIframeAPI() {
    await loadScript(LIMELIGHT_IFRAME_API_SRC);
    window.LimelightPlayerUtil.embed(this.videoSettings);
    this.getPlayer();
  }
}
